import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=efe9bb8c&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe9bb8c')) {
      api.createRecord('efe9bb8c', component.options)
    } else {
      api.reload('efe9bb8c', component.options)
    }
    module.hot.accept("./PageFooter.vue?vue&type=template&id=efe9bb8c&", function () {
      api.rerender('efe9bb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageFooter.vue"
export default component.exports